import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface PublicationsManage {
  name: string;
  api_token: string;
}

export interface PublicationsManageDetaiInfor {
  errors: unknown;
  PublicationsManage: PublicationsManage;
  isAuthenticated: boolean;
}

@Module
export default class PublicationsManageDetail
  extends VuexModule
  implements PublicationsManageDetaiInfor
{
  errors = {};
  PublicationsManage = {} as PublicationsManage;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get PublicationsManageDetail() {
    return this.publicationsManageDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.PUBLICATIONS_MANAGE_DETAIL_DATA](PublicationsManage) {
    this.publicationsManageDetailData = PublicationsManage;
  }
  @Action
  [Actions.PUBLICATIONS_MANAGE_DETAIL](payload) {
    return ApiService.getDataDetail("/publications", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.PUBLICATIONS_MANAGE_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
